import { Grid } from "@mui/material";
import React from "react";
import ExcelExportButton from "./excelExportButton";
import SearchForNameInput from "./searchForNameInput";
import FilterCheckboxes from "./filterCheckboxes";

const AppointmentListFilter = (): React.JSX.Element => (
  <Grid container sx={{ mb: 2 }}>
    <Grid item xs={12} sm={2}>
      <SearchForNameInput />
    </Grid>

    <Grid
      item
      xs={12}
      sm={8}
      sx={{
        textAlign: "center",
      }}
    >
      <FilterCheckboxes />
    </Grid>

    <Grid item xs={12} sm={2}>
      <ExcelExportButton />
    </Grid>
  </Grid>
);

export default AppointmentListFilter;
